import {AbstractControl, ValidationErrors} from '@angular/forms';

export function ValidDate(minAge = 18, maxAge = 120) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value === '__/__/____') {
      return {required: true};
    }

    const [day, month, year] = value.split('/').map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return {minlength: true};
    }

    const birthDate = new Date(year, month - 1, day);

    if (
      birthDate.getFullYear() !== year ||
      birthDate.getMonth() !== month - 1 ||
      birthDate.getDate() !== day
    ) {
      return {age: true};
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age >= minAge && age < maxAge ? null : {age: true};
  };
}



export function notFutureDate() {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value === '__/__/____') {
      return { required: true };
    }

    const [day, month, year] = value.split('/').map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return { minlength: true };
    }

    const date = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return { dateInvalid: true };
    }

    if (date > today) {
      return { futureDate: true };
    }

    return null;
  };
}
